"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isLocationPointValue = void 0;
const primitives_1 = require("./primitives");
const objects_1 = require("./objects");
const arrays_1 = require("./arrays");
const isLocationPointValue = (value) => {
    if (!(0, objects_1.isObjectWithKeysValue)(value, ["type", "coordinates"]))
        return false;
    return (0, primitives_1.isStringValue)(value.type) && (0, arrays_1.isArrayOfNumbersValue)(value.coordinates);
};
exports.isLocationPointValue = isLocationPointValue;
